export default class CurrentSearchCtrl{

}